import React from 'react';

const CTA = () => {
	return (
		<div className='cta'>
			<a
				href='https://res.cloudinary.com/dhoecmw9w/image/upload/v1698867470/e933uwmjdgypabmxj4k2.pdf'
				download
				rel='noreferrer'
				target='_blank'
				className='btn'
			>
				Download CV
			</a>
		</div>
	);
};

export default CTA;
